import { useMemo } from 'react'
import Player from '../components/Player'
import { useXp } from '../contexts/XpContext'
import { useScreenBreakpoint } from '../hooks/toolkit'

const SinglePlayer = () => {
  const { patterns, active } = useXp()
  const breakpoint = useScreenBreakpoint()

  const activeSpot = useMemo(() => active[0], [active])

  const bottom = useMemo(() => {
    if (breakpoint === 'sm') return 0
    if (patterns.length > 1) return 84
    return 24
  }, [patterns, breakpoint])

  if (!activeSpot) return null

  return (
    <div
      className={`
        absolute w-full md:w-[27rem]
        md:left-1/2 md:-translate-x-1/2
        shadow rounded overflow-hidden z-[999]
      `}
      style={{ bottom }}
      data-testid="player-card"
    >
      <Player spot={activeSpot} />
    </div>
  )
}

export default SinglePlayer
